
























import { Vue, Component, Prop } from 'vue-property-decorator';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import SelectionField from '@/components/common/inputs/SelectionField.vue';
import { ITSystem } from '@/store/modules/commonInterfaces';

@Component({
  components: {
    DeleteIcon,
    SelectionField
  }
})
export default class TagSelector extends Vue {
  @Prop(Boolean) disabled!: boolean;
  @Prop(Boolean) hasError!: boolean;
  @Prop(String) placeholder!: string;
  @Prop(Array) value!: ITSystem[];
  @Prop(Array) items!: ITSystem[];

  item: ITSystem | null = null;

  addTag(item: ITSystem) {
    if (!item) {
      return;
    }

    this.item = item;
    this.$emit('add', item);
  }

  removeTag(index: number) {
    this.item = null;
    this.$emit('remove', index);
  }
}
